<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="6">Poor Student Application Note</el-col>
            <el-col :span="14">
                <tinymceVue v-if="dialogVisible" :value-key="daa" v-model="form.poorStudentApplicationNote"></tinymceVue>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import tinymceVue from '@/components/tinymceVue'
    export default {
        components:{tinymceVue},
         data() {
            return {
               dialogVisible: false,
            }
        },
         computed:{
            daa(){
                 return new Date() + ((Math.random() * 1000).toFixed(0) + '')
                    
            },
        },
         props:{
            form:{
                type:Object,
                default:function(){}
            }
        },
         watch:{
            form:{
                handler(newVal){
                    if(newVal)
                    this.dialogVisible = true
                    this.$forceUpdate()
                },
                deep:true,
                immediate:true
              }
        },
    }
</script>

<style lang="scss" scoped>

</style>